module.exports = __webpack_public_path__ + "img/svdpvic.08f6713.png";